module.exports = __webpack_public_path__ + "static/media/penguinbackgrounddark.610143d5.jpg";